module.exports = __webpack_public_path__ + "media/a4.de277631.wav";